import { Box, Button, CircularProgress, FormControl, IconButton, InputAdornment, Typography, withStyles } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Styles from "../commonStyles";
import AuthContainer from "../_components/AuthContainer";
import CommonPopup from "../_components/CommonPopup";
import InputPaper from "../_components/InputPaper";
import PasswordPolicy from "../_components/PasswordPolicy";
import TBTooltip from "../_components/TBTooltip";
import strings from "../_constants/strings";
import actions from "../_fpactions/fpswdactions";
import { CssOutlinedInput } from "../_components/Input";
import { Visibility, VisibilityOff } from "@material-ui/icons";

function Password(props) {
  const { classes, id, name, value, label, disabled, placeholder, onChange, error, autoFocus, inputProps, user } = props;

  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl variant="outlined" className={user ? classes.passwordFormControl : classes.formControl}>
      <Typography className={classes.fieldTitle}>{label}</Typography>
      <CssOutlinedInput
        id={id}
        type={showPassword ? 'text' : 'password'}
        fullWidth
        autoFocus={autoFocus}
        name={name}
        value={value}
        variant="outlined"
        disabled={disabled}
        placeholder={placeholder}
        onChange={onChange}
        endAdornment={<InputAdornment position="end">
          <IconButton
            aria-label="toggle password visibility"
            onClick={() => setShowPassword(!showPassword)}
            edge="end"
          >
            {showPassword ? <Visibility className={classes.passwordIcon} /> : <VisibilityOff className={classes.passwordIcon} />}
          </IconButton>
        </InputAdornment>}
        error={error}
        inputProps={inputProps}
      />
    </FormControl>
  )
}

function ChangePassword(props) {
  const { classes, state, setState, callBack, user } = props;
  const {
    TITLES: { CHANGE_PASS },
    LABELS: { OLD_PASSWORD, NEW_PASSWORD, CONFIRM_PASSWORD },
    MESSAGES: { FIRST_LOGIN_CHANGE_PASS },
    ERRORS: { E_PASSWORD_MATCH, E_PASSWORD_CHECK },
  } = strings;

  const { submitting } = state;
  const [openPopUp, setOpenPopup] = useState(false)

  useEffect(() => {
    if (state.error.msg === "Invalid Auth Token.") {
      setOpenPopup(true)
    }
  }, [state, openPopUp]);

  const handlepasswordsubmit = e => {
    console.log("handlepasswordsubmit   e:", e)
    e && e.preventDefault();
    if (!state.newpassword || state.error.newpassword
      || !state.confirmpassword || state.error.confirmpassword
      || (user && !state.oldpassword) /* || (user && state.error.oldpassword) */) {
      setState({ type: actions.NEW_PASSWORD_SUBMIT_FAILURE, data: E_PASSWORD_CHECK });
    } else {
      setState({ type: actions.SUBMIT_PASSWORD, callBack, user });
      callBack && callBack();
    }
  };

  const handlepopup = () => {
    window.open("/", "_self")
  }
  const handleOldPassword = e => {
    setState({
      type: "ENTER_OLDPASSWORD",
      data: e.target.value
    });
  };

  const handlenewpassword = e => {
    setState({
      type: "ENTER_NEWPASSWORD",
      data: e.target.value
    });
  };

  const handleconfirmpassword = e => {
    setState({
      type: "CONFIRM_PASSWORD",
      data: e.target.value
    });
  };

  return (
    <AuthContainer formtype="change password">
      <Box className={classes.formBox} style={{ height: "100%" }}>
        <div style={{ width: "100%" }}>
          <Typography className={classes.formtitle}>
            {CHANGE_PASS}
          </Typography>

          {user && user.isFirstLogin && <Typography style={{ fontSize: 14, marginBottom: 10, marginTop: -10 }}>
            {FIRST_LOGIN_CHANGE_PASS}
          </Typography>}

          {/* {user &&
            <InputPaper
              autoFocus
              inputtype="password"
              value={state.oldPassword}
              name={OLD_PASSWORD}
              placeholder={OLD_PASSWORD}
              error={state.error.oldPassword ? true : false}
              handler={handleOldPassword}
              alt_text="newpassword-icon"
              disabled={submitting}
            />
          } */}
          {
            user &&
            <Password
              id="oldpassword"
              autoFocus={true}
              name="oldpassword"
              label={OLD_PASSWORD}
              value={state.oldPassword}
              variant="outlined"
              disabled={submitting}
              placeholder={`Enter your Old Password`}
              onChange={handleOldPassword}
              error={state.error.oldPassword ? true : false}
              inputProps={{
                'aria-label': 'Old Password'
              }}
              classes={classes}
              user={user}
            />
          }
          {/* <InputPaper
            autoFocus={!user}
            inputtype="password"
            value={state.newpassword}
            name={NEW_PASSWORD}
            placeholder={NEW_PASSWORD}
            error={state.error.newpassword ? true : false}
            handler={handlenewpassword}
            image="../images/changepass1st.svg"
            alt_text="newpassword-icon"
            errorMsg={!!state.error.newpassword ? <PasswordPolicy /> : null}
            disabled={submitting}
          />

          <InputPaper
            inputtype="password"
            value={state.confirmpassword}
            name={CONFIRM_PASSWORD}
            placeholder={CONFIRM_PASSWORD}
            error={state.error.confirmpassword ? true : false}
            handler={handleconfirmpassword}
            image="../images/changepass2nd.svg"
            alt_text="confirmpassword-icon"
            errorMsg={!!state.error.confirmpassword ? E_PASSWORD_MATCH : null}
            disabled={submitting}
          /> */}
          <TBTooltip
            // placement={errorPos}
            open={!!state.error.newpassword ? true : false}
            title={!!state.error.newpassword ? <PasswordPolicy /> : null}
          >
            <Password
              id="newpassword"
              autoFocus={!user}
              value={state.newpassword}
              name={'newpassword'}
              label={NEW_PASSWORD}
              variant="outlined"
              disabled={submitting}
              placeholder={`Enter your New Password`}
              onChange={handlenewpassword}
              error={state.error.newpassword ? true : false}
              inputProps={{
                'aria-label': 'New Password'
              }}
              classes={classes}
              user={user}
            />
          </TBTooltip>
          <TBTooltip
            // placement={errorPos}
            open={!!state.error.confirmpassword ? true : false}
            title={!!state.error.confirmpassword ? E_PASSWORD_MATCH : null}
          >
            <Password
              id="confirmpassword"
              autoFocus={false}
              name={'confirmpassword'}
              label={CONFIRM_PASSWORD}
              value={state.confirmpassword}
              variant="outlined"
              disabled={submitting}
              placeholder={`Confirm your New Password`}
              onChange={handleconfirmpassword}
              error={state.error.confirmpassword ? true : false}
              inputProps={{
                'aria-label': 'Confirm New Password'
              }}
              classes={classes}
              user={user}
            />
          </TBTooltip>
        </div>
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
          <Typography
            className={classes.errormsg}
            variant="caption"
            display="block"
            gutterBottom
          >
            {state.error.msg}
          </Typography>

          <Button
            variant='contained'
            type="submit"
            className={classes.blueButton}
            onClick={handlepasswordsubmit}
            disabled={submitting}
          >
            Update Password
            {submitting ? <CircularProgress size="15" className={classes.spinner} /> : ""}
          </Button>
          <TBTooltip
            title={<PasswordPolicy />}>
            <Typography
              className={classes.fgtpasswdlink}
              style={{ color: "#006276", cursor: "pointer", marginTop: user ? 0 : 8 }}>
              Password Policy
            </Typography>
          </TBTooltip>
        </div>
        <CommonPopup
          openState={openPopUp}
          popupText={state.error.msg}
          handleClick={handlepopup}
        ></CommonPopup>
      </Box>
    </AuthContainer>
  );
}
export default withStyles(Styles)(ChangePassword);
